import {Link, useLocation} from 'react-router-dom'
import { useModalContext } from "../../context/ModalContext";
import styles from "../Footer/footer.scss";
import Logo from "../../assets/VeloPage/velo-logo.svg";

const Footer = ({ footerType, langData, lang }) => {
  const { handleOpenCookieModal, handleCloseAgeGate } = useModalContext();
  const temporaryUrl = 'lv/lv/';
  const location = useLocation();

  const { pathname } = location;

  const handleClick = () => {
    handleCloseAgeGate()
    handleOpenCookieModal();
  }

  return (
    <>
      <footer className="footer">
        <div className="container--center">
          <p className='desktop-footer-year'>© VELO  2023</p>
          <div className="footer-inner">
            <div className="logo">
              <img src={Logo} alt='Velo Logo'/>
              <p className='mobile-footer-year'>© VELO  2023</p>
            </div>
            <div className="footer-nav-block">
              <h4>{ langData.customer_service.title }</h4>
              <div className="footer-nav-content">
                {/* <Link to={`/${lang}/faq`} className="footer-link">
                  {langData.customer_service.link}
                </Link> */}
                <Link to={`/lv/lv/faq`} className="footer-link">
                  {langData.customer_service.link}
                </Link>
              </div>
            </div>
            <div className="footer-nav-block">
              <h4>{ langData.policies.title }</h4>
              <div className="footer-nav-content">
                <a href={pathname.includes("forbidden") ? "" : "/lv/lv/assets/sikdatnu-uzstadijumi.pdf"} style={{pointerEvents: pathname.includes("forbidden") ? "none" : ""}} target="_blank" rel="noopener noreferrer" className="footer-link">
                  { langData.policies.cookie_policy }
                </a>
                <button onClick={handleClick} className="footer-link">
                  {langData.policies.cookie_settings}
                </button>
              </div>
            </div>
            <div className="footer-nav-block">
              <h4>{ langData.contact.title }</h4>
              <div className="footer-nav-content">
                <p className="contact-info">{ langData.contact.importer }:<br/>
                „MV GROUP Distribution LV”, <br/> Medus Iela 7, <br/> LV-1048 Riga,<br/> Latvia, <br/>+371 67930211 <br/> </p>
                {/* <p>{ langData.contact.help}<a href="mailto:tagasiside@bat.com">tagasiside@bat.com</a></p>
                <a href="mailto"></a> */}
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div
        className="disclaimer">
        <button onClick={handleClick} className="cookie-button">
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.9957 10.2176C20.9842 9.79977 20.5834 9.47894 20.1793 9.58431C19.6957 9.71098 19.1874 9.70905 18.7047 9.57874C18.2221 9.44842 17.7818 9.19423 17.4275 8.84133C17.3009 8.71254 17.1865 8.57237 17.0857 8.42259C17.0075 8.3029 16.8938 8.21074 16.7605 8.15906C16.6273 8.10738 16.4812 8.09878 16.3428 8.13446C15.8622 8.2573 15.358 8.25284 14.8797 8.12154C14.4014 7.99024 13.9654 7.73662 13.6148 7.38561C13.2641 7.0346 13.0108 6.5983 12.8797 6.11961C12.7487 5.64093 12.7444 5.13635 12.8673 4.65551C12.9027 4.51711 12.894 4.37109 12.8424 4.23789C12.7907 4.1047 12.6988 3.991 12.5793 3.91273C12.4306 3.8122 12.2919 3.69768 12.1649 3.57074C11.8119 3.21775 11.5575 2.77836 11.4269 2.29634C11.2964 1.81432 11.2943 1.3065 11.421 0.823436C11.5267 0.417104 11.2041 0.0156858 10.7846 0.00435655C9.35809 -0.0368339 7.93822 0.214426 6.61231 0.742685C5.28641 1.27094 4.08251 2.06503 3.07464 3.07612C-1.14251 7.29615 -1.02012 14.2081 3.43328 18.2749C7.41419 21.9084 13.5867 21.9084 17.5676 18.2749C18.6861 17.2589 19.5716 16.0127 20.1634 14.6219C20.7551 13.2311 21.039 11.7286 20.9957 10.2176ZM6.20777 9.86838C5.80972 9.77496 5.44385 9.57681 5.14801 9.29443C4.85216 9.01205 4.63709 8.65569 4.52504 8.26224C4.413 7.86878 4.40804 7.4525 4.5107 7.05649C4.61335 6.66047 4.81988 6.29909 5.10892 6.00974C5.39796 5.72039 5.75902 5.51358 6.15473 5.4107C6.55044 5.30782 6.96643 5.31262 7.35966 5.42459C7.7529 5.53656 8.10909 5.75164 8.3914 6.04757C8.6737 6.34351 8.87186 6.70955 8.96537 7.10783C9.05941 7.48895 9.05352 7.8879 8.94829 8.26608C8.84306 8.64425 8.64205 8.98883 8.36471 9.26647C8.08737 9.54411 7.7431 9.74539 7.36522 9.85084C6.98734 9.95629 6.58866 9.96233 6.20777 9.86838ZM9.54595 15.4547C9.49527 15.6907 9.38172 15.9087 9.21734 16.0854C9.05295 16.2622 8.84385 16.3911 8.61218 16.4586C8.38052 16.5261 8.13493 16.5296 7.90143 16.4688C7.66794 16.4079 7.45523 16.285 7.28586 16.1131C7.11649 15.9411 6.99675 15.7265 6.93935 15.492C6.88195 15.2575 6.88901 15.0118 6.95979 14.781C7.03057 14.5502 7.16243 14.3428 7.3414 14.1809C7.52038 14.019 7.73979 13.9085 7.97639 13.8612C8.19382 13.8179 8.41858 13.8294 8.63048 13.8946C8.84238 13.9598 9.03478 14.0766 9.1904 14.2346C9.34601 14.3926 9.45997 14.5868 9.52203 14.7997C9.58409 15.0127 9.59231 15.2378 9.54595 15.4547V15.4547ZM17.0784 12.8083C17.0282 13.1214 16.8926 13.4146 16.6864 13.6555C16.4802 13.8963 16.2115 14.0755 15.9099 14.1732C15.6084 14.2709 15.2858 14.2833 14.9776 14.209C14.6695 14.1348 14.3878 13.9768 14.1638 13.7525C13.9397 13.5282 13.782 13.2463 13.7079 12.9379C13.6338 12.6295 13.6464 12.3067 13.7441 12.005C13.8419 11.7033 14.021 11.4345 14.2618 11.2282C14.5026 11.022 14.7956 10.8863 15.1086 10.8363C15.3768 10.795 15.6509 10.8176 15.9088 10.9021C16.1666 10.9867 16.401 11.1308 16.5928 11.3228C16.7846 11.5149 16.9286 11.7494 17.0129 12.0075C17.0973 12.2656 17.1197 12.5399 17.0784 12.8083V12.8083Z" fill="#041E42" />
          </svg>
        </button>
        <p>{langData.warning}</p>
      </div>
    </>
  );
};

export default Footer;
